import React from "react";
import { Card, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

const BrandCard = ({ img, id , brand }) => {
  return (
    <Col
      className="my-2 d-flex justify-content-center"
    >
      <Card
        className="brand-card-image-container"
        style={{
          width: "230px",
          borderRadius: "8px",
          border: "none",
          backgroundColor: "#FFFFFF",
        }}
      >
        <Link to={`/products/brand/${id}?page=1`} title={brand?.nameAr} style={{ textDecoration: 'none' }}>
          <Card.Img
          className="brand-card-image"
            src={img}
            loading="lazy"
          />
        </Link>
      </Card>
    </Col>
  );
};

export default BrandCard;
